import classes from "./integrationStyles.module.scss"
import { useEffect, useState } from 'react';
import XMLViewer from 'react-xml-viewer'

const InvoiceDocsXmlViaUrl = ({xml, onExecuteResponse, minHeight=true, ...props})=>{
    const [keyState, setKeystate] = useState(0);
    const [xmlData, setXmlData] = useState("");
    useEffect(() => {
        setKeystate(keyState+1)
    }, [onExecuteResponse])

    useEffect(() => {
        if(!xml)
            return setXmlData("");
        reloadXml(xml);
    }, [xml]);

    const reloadXml = (path) => {
        if(!path)
            return setXmlData("");
        fetch(process.env.REACT_APP_API_ENDPOINT ? "/xml_example.xml" : path)
            .then(res => res.text())
            .then(xmlString => {
                setXmlData(xmlString);
            })
    }

    return(<>
    {/* <div className={`${classes["container-limit"]}`} style={minHeight ? {minHeight:"80vh"} :  {width:"100%"}}> */}
        {/* <textarea value={xml} style={{width:"100%", height:"100%", whiteSpace:"pre"}} disabled/> */}
        <XMLViewer xml={xmlData} style={{overflowWrap:"normal"}}/>
    {/* </div> */}
    </>)
}

export default InvoiceDocsXmlViaUrl;